// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__NmxM4","content":"GlobalSearch_content__tTNDE"};